import { URLS, cr, interact, ck } from "fire-wind-water";
export const browseInfo: any = interact.browseInfo;
import { smkmoduleIds } from "../modules/settings/modules";
import { config as sconf } from "../conf/settings";

export const utm = {
  source: URLS.getURL("utm_source"),
  medium: URLS.getURL("utm_medium"),
  campaign: URLS.getURL("utm_campaign"),
  content: URLS.getURL("utm_content"),
  term: URLS.getURL("utm_term"),
};

export const source = URLS.getURL("source");

if (source) {
  browseInfo.source = source;
}

cr.each(utm, (o, k) => {
  if (o) {
    utm[k] = decodeURIComponent(o);
    sessionStorage.setItem(`utm_${k}`, utm[k]);
  } else {
    const v = sessionStorage.getItem(`utm_${k}`);
    if (v) {
      utm[k] = v;
    }
  }
  if (utm[k]) {
    //browseInfo[`utm_${k}`] = utm[k];
  }
});

let x: any = sessionStorage.getItem("sk_initial");
if (x) {
  x = JSON.parse(x);
}

export const channelModel = {
  common() {
    return { common: {} };
  },
  skInit() {
    if (!x) {
      const m = this.common().common;
      const o: any = {
        moduleId: m.moduleId,
        instanceId: m.instanceId,
        type: m.type,
        objId: m.activityId,
        objModuleId: smkmoduleIds[m.type],
      };
      if (!o.objModuleId) {
        if (o.type === "instance") {
          o.objModuleId = m.moduleId;
        }
      }
      x = o;
      sessionStorage.setItem("sk_initial", JSON.stringify(o));
      cr.each(o, (d, k) => {
        browseInfo[k] = d;
      });
    }
  },
};

export const paramsList = [
  "globalUserId",
  "weChatId",
  "tenantId",
  "instanceId",
  "moduleId",
  "configId",
  "randNum",
  "linkId",
  "return_url",
  "customFormId",
  "questionaryId",
  "pollId",
  "luckyDrawId",
  "articleId",
  "memberFormId",
  "folderId",
  "accKey",
  "articleCategoryId",
  "fileId",
  "memberSchemaId",
  "sourceKey",
  "webinarId",
  "backUrl",
  "memberId",
  "pk_campaign",
  "pk_source",
  "timestamp",
  "back_returnUrl",
];
export const  firstChannelParams = [
  'firstTenantId',
  'firstModuleId',
  'firstInstanceId',
  'firstObjModuleId',
  'firstObjId',
  'firstProgramId',
  'firstObjectTitle',
  'markCode',
  'marketingTaskId',
  'send_task_code'];


function getHashSearchParam() {
  const url = window.location.href;
  // 获取 hash 值，不包含 '#' 号
  const hash = url.substring(url.indexOf("#") + 1);
  // 查找 '?' 号所在的索引
  const searchIndex = hash.indexOf("?");
  // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : "";
  // 把搜索参数字符串提过URLSearchParams转成对象形式
  const usp = new URLSearchParams(search);
  usp.delete("return_url");
  usp.delete("returnUrl");
  usp.delete("backUrl");
  // 通过URLSearchParams自带的get方法，查询键所对应的值
  return usp.toString();
}

function checkHashMarkcode(url) {
  const hash = url.substring(url.indexOf("#") + 1);
  // 查找 '?' 号所在的索引
  const searchIndex = hash.indexOf("?");
  // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : "";
  const usp = new URLSearchParams(search);
  if (usp.has("markCode")) {
    const markCode = usp.get("markCode");
    if (markCode && markCode != "undefined") {
      return markCode;
    }
  }
  return false;
}

function getChannelParamArray() {
  const hashStr = getHashSearchParam();
  const channelVal = ['track_id', 'markCode'];
  let searchStr = window.location.search.substr(1);
  if (hashStr) {
    searchStr = searchStr + "&" + hashStr;
  }
  let hasTrack = false;
  const searchArr = searchStr.split("&");
  const result: any = {};
  for (let i = 0; i < searchArr.length; i++) {
    const d = searchArr[i].split("=");
    if (
      paramsList.indexOf(d[0]) === -1 &&
      d[1] !== "" &&
      d[1] !== null &&
      d[1] !== undefined
    ) {
      let temp = decodeURIComponent(d[1].toString());
      if (temp.indexOf("#") !== -1) {
        temp = temp.substring(0, temp.indexOf("#"));
      }
      if (channelVal.indexOf(d[0]) !== -1) {
        hasTrack = true;
      }
      result["channel_" + d[0]] = temp;
    }
  }
  if (!hasTrack) {
    return {};
  }
  return result;
}

//获取地址栏的渠道追踪参数写入cookies
export function saveChannelParams(searchArr: any = {}) {
  ck.json = true;
  if (cr.isEmptyObject(searchArr)) {
    searchArr = getChannelParamArray();
  }
  const channelList = ck.cookie();
  if (cr.isEmptyObject(searchArr)) {
    return channelList;
  } else {
    //console.log("保存track_id: " + JSON.stringify(searchArr));
    //清除之前保存的channel_值，保存新的渠道
    const firstTenantId = ck.cookie("channel_firstTenantId") || null;
    const firstTrack = ck.cookie("channel_firstTrack") || null;
    let tenantId = null;
    if ((window as any).$sk && (window as any).$sk.config) {
      tenantId = (window as any).$sk.config.tenantId || null;
    }
    if (tenantId == null || tenantId === '') {
      return channelList;
    }
    //如果不是首次进入，则不记录推广渠道
    const objId = ck.cookie("channel_firstObjId") || null;
    if (firstTrack !== 1 && firstTenantId && firstTenantId === tenantId && objId && objId !== 0 && objId !== null) {
      return channelList;
    }
    // 循环遍历对象的属性
    for (const val in channelList) {
      // eslint-disable-next-line no-prototype-builtins
      const valt = val.replace("channel_", "");
      if (
        channelList[val] &&
        val.indexOf("channel_") !== -1 &&
          firstChannelParams.indexOf(valt) === -1
      ) {
        ck.removeCookie(val, { path: "/", domain: sconf.domain });
      }
    }
    cr.each(searchArr, (d, k) => {
      ck.cookie(k, d, {
        domain: sconf.domain,
        path: "/",
      });
    });
    const urlparams = {...searchArr, ...channelList};
    return urlparams;
  }
}
export function getChannelParams() {
  ck.json = true;
  //获取完整url
  const browseChannel = browseInfo;
  // 全员营销不需要追加参数
  const hasMarkcode = checkHashMarkcode(window.location.href);
  if (hasMarkcode) {
    //return browseChannel;
  }
  //来源渠道取cookie里首次进入的渠道，如果没有首次参数，则从地址栏取后并存入
  /*let channelList = getChannelParamArray();
  if (cr.isEmptyObject(channelList)) {
    channelList = ck.cookie();
  } else {*/
    //不空需要写到cookie里
  const channelList = saveChannelParams();
    //因为没有从cookile取, 判断是否有channel_send_task_code 邮件/短信任务生成线索code
    /*const taskCode: string = ck.cookie("channel_send_task_code") || null;
    if (taskCode) {
      channelList["channel_send_task_code"] = taskCode;
    }*/
    //需要获取出来源首次的参数
    /*const firstChannel = ck.cookie();
    for (const valc in firstChannel) {
      const valtc = valc.replace("channel_", "");
      if (valc.indexOf("channel_") !== -1 &&
          firstChannelParams.indexOf(valtc) !== -1
      ) {
        channelList[valc] = firstChannel[valc];
      }
    }*/
 // }
  // 循环遍历对象的属性
  for (const val in channelList) {
    // eslint-disable-next-line no-prototype-builtins
    if (
      // eslint-disable-next-line no-prototype-builtins
      channelList[val] &&
      val.indexOf("channel_") !== -1
    ) {
      const temp = val.replace("channel_", "");
      browseChannel[temp] = channelList[val];
    }
  }
  const marketingSess: string = ck.cookie("marketingSess") || null;
  if (marketingSess) {
    browseChannel['marketingSess'] = marketingSess;
  }
  return browseChannel;
}
